import { Seo, breadcrumbJsonLd } from "@/lib/Seo";
import { PageHeader } from "@/components/PageHeader";
import { WorkMethod } from "@/sections/WorkMethod";
import { Reliability } from "@/sections/Reliability";
import { ContactSection } from "@/sections/ContactSection";

const BREADCRUMB = [
  { name: "Home", path: "/" },
  { name: "Werkwijze", path: "/werkwijze" },
];

export default function WorkMethodPage() {
  return (
    <>
      <Seo
        title="Onze werkwijze | Brandpreventie Recycling"
        description="Van kennismaking en locatieanalyse tot installatie, testen en onderhoud: zo ontwerpt Beveilig Alles B.V. een thermische detectieoplossing voor uw recyclingbedrijf."
        jsonLd={[breadcrumbJsonLd(BREADCRUMB)]}
      />
      <PageHeader
        overline="Werkwijze"
        title="Van risicoanalyse tot werkend alarmscenario"
        intro="Een betrouwbaar detectiesysteem vraagt om een zorgvuldig proces. In zes stappen brengen we uw locatie, risico's en gewenste alarmopvolging in kaart."
        breadcrumb={BREADCRUMB}
      />
      <WorkMethod />
      <Reliability />
      <ContactSection />
    </>
  );
}
